
export const environment = {
  production: true,
  apiUrl: 'https://fake-news-combat-agency.onrender.com',
  recaptchaSiteKey: '6Lf7M-AsAAAAAGFPe_xeEAZWo3vti9k0ICPDap0j'
};
